import { Option } from '~/core/shared/types';

export enum PersonalAsset {
  MotorVehicle = 'motor_vehicle',
  RealEstate = 'real_estate',
  BankAccount = 'bank_account',
  OtherAsset = 'other_asset',
  HomeContents = 'home_contents',
  SharesAndInvestments = 'shares_and_investments',
  Superannuation = 'superannuation',
}

export const PERSONAL_ASSET_OPTIONS: Option<string>[] = [
  {
    label: 'Motor vehicle',
    value: PersonalAsset.MotorVehicle,
  },
  {
    label: 'Real estate',
    value: PersonalAsset.RealEstate,
  },
  {
    label: 'Bank account',
    value: PersonalAsset.BankAccount,
  },
  {
    label: 'Other personal assets',
    value: PersonalAsset.OtherAsset,
  },
  {
    label: 'Home contents',
    value: PersonalAsset.HomeContents,
  },
  {
    label: 'Shares/Investments',
    value: PersonalAsset.SharesAndInvestments,
  },
  {
    label: 'Superannuation',
    value: PersonalAsset.Superannuation,
  },
];
